import { FRAME_CHARGER_SERIAL } from '../../consts/scpConsts';
import FrameProcessingService from './frameProcessingService';

const PING_INTERVAL_MS = 3000;

class DevicePingService {
    constructor() {
        this.pingSchedulers = {};
    }

    startPing(deviceId) {
        if (this.pingSchedulers[deviceId]) {
            return;
        }

        const frameProcessingService = new FrameProcessingService(deviceId);
        this.pingSchedulers[deviceId] = setInterval(() => {
            frameProcessingService.addFrameToQueue({
                frame: FRAME_CHARGER_SERIAL,
                timeout: 3000,
            });
        }, PING_INTERVAL_MS);
    }

    stopPing(deviceId) {
        if (!this.pingSchedulers[deviceId]) {
            return;
        }

        clearInterval(this.pingSchedulers[deviceId]);
        delete this.pingSchedulers[deviceId];
    }
}

export default new DevicePingService();
